var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoGiftCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5h-4.762a4.457 4.457 0 0 1 .712 2H20a1 1 0 0 1 1 1v1h-6.354a3.491 3.491 0 0 0-5.621-3.975A5.6 5.6 0 0 0 8 6.715a5.6 5.6 0 0 0-1.025-1.69 3.5 3.5 0 0 0-4.95 4.95 5.529 5.529 0 0 0 3.248 1.007 16.578 16.578 0 0 0-2.664 3.564l1.781.908A15.036 15.036 0 0 1 8 11.2a15.036 15.036 0 0 1 3.609 4.256l1.781-.908A16.552 16.552 0 0 0 10.743 11H21v6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-3.471a12.61 12.61 0 0 0-1.719 2.38L5 16.46V17a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3zM3.438 8.559a1.5 1.5 0 0 1 2.123-2.12 7.916 7.916 0 0 1 1.144 2.592 7.849 7.849 0 0 1-3.267-.472zm9.125 0A5.577 5.577 0 0 1 10.218 9h-.913a7.948 7.948 0 0 1 1.134-2.561 1.5 1.5 0 0 1 2.124 2.12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGiftCard);
export default __webpack_public_path__ + "static/media/ico_gift_card.1353b0aa92e9ff569ac69000ed6d3671.svg";
export { ForwardRef as ReactComponent };